import axios from "axios";
import route from "ziggy-js";
import { useQuery } from "@tanstack/vue-query";
import { groupBrandsByName, groupBrandsByTenant } from "@/Utils/brands";

const QUERY_KEY = ["brands"];

async function fetchBrands() {
    const { data } = await axios.get(route("api.preload.brands"));
    return data;
}

export const ParserType = Object.freeze({
    GROUP_BY_NAME: "group_by_name",
    GROUP_BY_TENANT: "group_by_tenant",
});

export const parsers = {
    [ParserType.GROUP_BY_NAME]: groupBrandsByName,
    [ParserType.GROUP_BY_TENANT]: groupBrandsByTenant,
};

export function useBrands(tenantIds = [], filterType = "all") {
    const parser =
        tenantIds.length === 1
            ? ParserType.GROUP_BY_TENANT
            : ParserType.GROUP_BY_NAME;

    return useQuery({
        queryKey: QUERY_KEY,
        queryFn: fetchBrands,
        refetchOnMount: true,
        select: (data) => parsers[parser](data, tenantIds, filterType),
    });
}
